import React, { Suspense, useDeferredValue } from 'react';
import { PageLoader } from 'shared/components/ui/page-loader';
import {
  CalendarViewOptions,
  UpcomingViewOptions,
} from 'shared/types/upcoming-view-options';

import { useCalendarViewControls } from '../../hooks/use-calendar-view-controls';
import { PageTopBar } from '../page-top-bar';
import { TasksOverview } from '../tasks-overview';
import { CalendarView } from './calendar-view';
import * as Styled from './main.style';

export type MainProps = {
  onToggleSidePanel: () => void;
  sidPanelOpen?: boolean;
  onChangeView: (view: UpcomingViewOptions) => void;
  selectedView: UpcomingViewOptions;
};

export const Main: React.FC<MainProps> = ({
  sidPanelOpen,
  onToggleSidePanel,
  selectedView,
  onChangeView,
}) => {
  const deferredSelectedView = useDeferredValue(selectedView);
  const {
    referenceDate: calendarReferenceDate,
    onChangeView: onChangeCalendarView,
    selectedView: selectedCalendarView,
    onToday,
    onBigNext,
    onBigPrev,
    scrollTime,
  } = useCalendarViewControls(true);

  const isTransitioningView = selectedView !== deferredSelectedView;

  return (
    <>
      <PageTopBar
        onPrev={onBigPrev}
        onToday={onToday}
        onNext={onBigNext}
        sidePanelOpen={sidPanelOpen}
        onToggleSidePanel={onToggleSidePanel}
        selectedCalendarView={selectedCalendarView ?? CalendarViewOptions.Week}
        changeCalendarView={onChangeCalendarView}
        changeSelectedView={onChangeView}
        selectedView={selectedView}
        referenceDate={
          selectedView === UpcomingViewOptions.Calendar
            ? calendarReferenceDate
            : undefined
        }
      />
      <Styled.Content>
        {isTransitioningView && <PageLoader />}
        {deferredSelectedView === UpcomingViewOptions.List && <TasksOverview />}
        {deferredSelectedView === UpcomingViewOptions.Calendar &&
          selectedCalendarView && (
            <Suspense fallback={<PageLoader />}>
              <CalendarView
                view={selectedCalendarView}
                referenceDate={calendarReferenceDate}
                scrollTime={scrollTime}
              />
            </Suspense>
          )}
      </Styled.Content>
    </>
  );
};
